import { Calendar, FileText, Shield, Settings } from 'lucide-react';
import { useFadeUp } from '@/hooks/useFadeUp';

const features = [
  { icon: Calendar, title: 'Intervention 7j/7', description: 'Dépannage rapide, même le week-end.' },
  { icon: FileText, title: 'Devis gratuit', description: 'Diagnostic et devis sans engagement.' },
  { icon: Shield, title: 'Garantie 10 ans', description: 'Pièces et main-d\'œuvre garanties.' },
  { icon: Settings, title: 'Toutes marques', description: 'Somfy, Bubendorff, Profalux, Simu, etc.' },
];

export function ReassuranceBand() {
  const ref = useFadeUp();

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div ref={ref} className="fade-up max-w-5xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {features.map((item, i) => {
            const Icon = item.icon;
            return (
              <div key={i} className="flex flex-col items-center text-center gap-3">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-accent-50 flex items-center justify-center">
                  <Icon className="w-6 h-6 md:w-7 md:h-7 text-accent-500" />
                </div>
                <div>
                  <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-700">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 mt-1 hidden sm:block">
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}